import ibesDeliveryReducer from './ibesDelivery.reducer';
export default ibesDeliveryReducer;

export * from './ibesDelivery.selectors';
